export default __webpack_public_path__ + "b1960db8498c06cd9bac66912b374ee3.svg";